import { newToolFilterOAuthMcp } from "../oauth.ts";

export const octagonMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/67e20964923f8dc825a5dbd0/67e20964923f8dc825a5dc20_favico.png",
  url: "https://mcp.octagonagents.com/mcp",
  label: "Octagon",
});
